import { render } from "./TemplateDemandConfirmation.vue?vue&type=template&id=46953f4a"
import script from "./TemplateDemandConfirmation.vue?vue&type=script&lang=js"
export * from "./TemplateDemandConfirmation.vue?vue&type=script&lang=js"
script.render = render

export default script